import {
  regularFiltersChange,
  regularFiltersSubmit,
} from 'containers/ResolutionCenter/IncidentFilters/actions'
import { selectRegularFilters } from 'containers/ResolutionCenter/IncidentFilters/selectors'
import quickFiltersActions from 'containers/ResolutionCenter/QuickFilters/actions'
import { selectQuickFilters } from 'containers/ResolutionCenter/QuickFilters/selectors'

import {
  buildServerFilterUpdates,
  serializeServerFilterPayload,
} from 'components/pages/resolutionCenter/redesign/adapters/filterMapping'

export const SAVE_DEFAULT_TIMEFRAME = 'INCIDENTS_REDESIGN/SAVE_DEFAULT_TIMEFRAME'
export const SAVE_DEFAULT_TIMEFRAME_SUCCESS = 'INCIDENTS_REDESIGN/SAVE_DEFAULT_TIMEFRAME_SUCCESS'

/** @param {number|null} df numeric dateFilter, or null to clear the user favorite */
export const saveDefaultTimeFrame = (df) => ({
  type: SAVE_DEFAULT_TIMEFRAME,
  payload: { df },
})

export const saveDefaultTimeFrameSuccess = (userDefaultIncidentDateFilter) => ({
  type: SAVE_DEFAULT_TIMEFRAME_SUCCESS,
  payload: { userDefaultIncidentDateFilter },
})

/**
 * Push the redesign filter chips to the store — but only when they actually change the request.
 *
 * A chip is added empty (the value dropdown opens after it appears), so `Add filter` on its own
 * contributes nothing to any server array. Dispatching regardless flips the list loader
 * (List/reducer on QUICK_FILTERS_CHANGE + REGULAR_FILTERS_SUBMIT) and refetches an identical page.
 * Clearing a chip's last value, by contrast, widens the results and must refetch.
 *
 * The comparison is against the store rather than component-side bookkeeping, so it can't drift when
 * something else rewrites the filters (tab switch, company switch, the legacy page).
 *
 * @returns {boolean} whether the change reached the store.
 */
export const applyChipFilters =
  (chips, { urlState, extraQuickFilters = [] } = {}) =>
  (dispatch, getState) => {
    const built = buildServerFilterUpdates(chips, { urlState })
    const regularFilters = built.regularFilters
    const quickFilters = extraQuickFilters.length
      ? [...new Set([...built.quickFilters, ...extraQuickFilters])]
      : built.quickFilters

    const state = getState()
    // Compare only the keys the chips own — regularFilters also carries dateFilter/customDateRange,
    // which the time-frame dropdown owns.
    const storeFilters = selectRegularFilters(state)
    const applied = serializeServerFilterPayload(
      Object.fromEntries(Object.keys(regularFilters).map((key) => [key, storeFilters[key]])),
      selectQuickFilters(state)
    )
    if (serializeServerFilterPayload(regularFilters, quickFilters) === applied) return false

    Object.entries(regularFilters).forEach(([key, value]) =>
      dispatch(regularFiltersChange(value, key))
    )
    dispatch(quickFiltersActions.quickFiltersChange(quickFilters))
    dispatch(regularFiltersSubmit())
    return true
  }
